(function (Drupal) {
  Drupal.behaviors.activeServices = {
    attach: function (context, settings) {
      const body = document.querySelector('body');
      const linkServices = document.querySelector(".highlighted .menu--main .nav-link--nuestros-servicios");
      const linkPrograms = document.querySelector(".highlighted .menu--main .nav-link--programas-y-especialidades");
      if (body.classList.contains("node--type-servicios")) {
        sessionStorage.setItem("lastSection", "services"); 
        if (linkServices) linkServices.classList.add("is-active");
        if (linkPrograms) linkPrograms.classList.remove("is-active");
      } 

      if (body.classList.contains("node--type-programas") || document.querySelector('.block-quicktabs-blocknuestras-especialidades')) {
        sessionStorage.setItem("lastSection", "programs"); 
        if (linkPrograms) linkPrograms.classList.add("is-active");
        if (linkServices) linkServices.classList.remove("is-active");
      }

      if (body.classList.contains("node--type-cv-especialista")) {
        const lastSection = sessionStorage.getItem("lastSection");

        if (lastSection === "services" && linkServices) {
          linkServices.classList.add("is-active");
        }
        if (lastSection === "programs" && linkPrograms) {
          linkPrograms.classList.add("is-active");
        }
      }
    }
  };
})(Drupal);
